import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEventType, HttpEvent, HttpResponse, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { AuthService } from 'app/services/auth.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router, CanActivate } from '@angular/router';

@Injectable()
export class UnauthorizeInterceptor implements HttpInterceptor {

	// Injector per ottenere AuthService/Router in modo lazy: un HTTP interceptor che
	// inietta Router nel costruttore causa NG0200 (ciclo DI Router<->HttpClient in init).
	constructor(private _injector: Injector) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const auth = this._injector.get(AuthService);
		return next.handle(request).pipe(
			tap((event: HttpEvent<any>) => {

				if(event.type == HttpEventType.Response){
					// console.log('intercepted event', request, event);
				}
				if (event instanceof HttpErrorResponse) {
					if (event.status === 401 && auth.isAuthenticated()) {
						auth.logout();
					}
				}
			}, (event: any) => {
				if (event instanceof HttpErrorResponse) {
					if (event.status === 401) {
						auth.userDataObserver.next(null);
						const router = this._injector.get(Router);
						const currentUrl = router.routerState.snapshot.url;
						if(currentUrl.startsWith('/auth/reset-password')
						|| currentUrl.startsWith('/auth/forgot-password')){
							return;
						}
						router.navigate(['auth/login']);
					}
				}
			})
		);
	}
}
